/**
 * 模型管理页面 · 参照 docs/mockups/model-management-ui.html 的信息架构:
 *   3 个子页在**左侧 Sidebar**「模型管理」分组下,不用顶部 Tabs。
 *
 * 路由:
 *   /model-management            → 兼容旧链接, 重定向到 /releases
 *   /model-management/releases   → 版本查询 (VersionQuery)
 *   /model-management/models     → 模型查询 (ModelQuery)
 *   /model-management/upload     → 模型上传 (Upload)
 *   /model-management/sync       → 模型同步 (ModelSync，中台发版同步)
 *
 * 页面顶部只保留一行「模型管理 › 子页名」面包屑, 视觉聚焦子页内容。
 */
import { useLocation } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import ModelQuery from './ModelQuery';
import VersionQuery from './VersionQuery';
import Upload from './Upload';
import ModelSync from './ModelSync';

interface SubPageSpec {
  path: string;
  label: string;
  Component: React.FC;
}

const SUB_PAGES: SubPageSpec[] = [
  { path: 'releases', label: '版本查询', Component: VersionQuery },
  { path: 'models', label: '模型查询', Component: ModelQuery },
  { path: 'upload', label: '模型上传', Component: Upload },
  { path: 'sync', label: '模型同步', Component: ModelSync },
];

export default function ModelManagementPage() {
  const location = useLocation();
  // 从 URL 尾段确定子页; 兜底 releases
  const seg = location.pathname.split('/').pop() || 'releases';
  const current = SUB_PAGES.find((p) => p.path === seg) ?? SUB_PAGES[0];
  const CurrentPage = current.Component;

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1560, margin: '0 auto' }}>
      <Breadcrumb
        style={{ marginBottom: 16, fontSize: 13 }}
        items={[{ title: '模型管理' }, { title: current.label }]}
      />
      <CurrentPage />
    </div>
  );
}
